import { render, staticRenderFns } from "./iconPaste.vue?vue&type=template&id=1ca847dc"
import script from "./iconPaste.vue?vue&type=script&lang=js"
export * from "./iconPaste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports